import http from "../http";

const reportSummaryService = {
    getReportSummary_Service: async (STDDay) => {
        // stdday
        //STDDay = new Date(2022,7,28)
        //alert("istek apiye gönderiliyor"+ STDDay);

        // const NetlineChangeVersions = await http.instance.get("/TechnicalHistory/GetNetline_History_GetAllChangesByLegNo/",{params:{LegNo:LegNo}});
        const reportSummary = await http.instance.get("/reportsummary/GetReportsBuilderSummariesWithTransferSummariesBySTDDay/",{params:{STDDay: STDDay}})   // {params:{LegNo:LegNo}}

        //alert(reportSummary.length)
        console.log(reportSummary)
        return reportSummary
    },

    getReportBuildList_Service: async () => {
        // waitinglist
        //alert("getReportBuildList_Service")
        const buildList = await http.instance.get("/ReportSummary/GetWaitingReportBuildList/")
        //alert(buildList.length)
        console.log("buildList")
        console.log(buildList)
        return buildList
    },

    RegenerateReports_Service : async (SelectedDay) =>
    {

        // SelectedDay = new Date('2011-07-14 11:23:00');
        // alert(SelectedDay)

        // const Req_GenerateReportModel = new FormData();
        // alert("Selectedday"+ SelectedDay)
        // Req_GenerateReportModel.set("SelectedDay",SelectedDay);

        const result = await http.instance.post("/ReportSummary/RegenerateReportsBySelectedDay/",{params:{SelectedDay: SelectedDay}});
        // parametre başarılı birşekilde işlendi...
        //const result = http.instance.post("/TechnicalHistory/ForceManuallyUpdate/", forceManuallyModel);
        return result.data;
    },

    RegenerateReports_Service_ByIPADLKVOO : async (IDIPADLKVOO) =>
    {
        const Req_GenerateReportModel = new FormData();
        Req_GenerateReportModel.set("IDIPADLKVOO", IDIPADLKVOO);
        const result = await http.instance.post("/ReportSummary/RegenerateReportsByIDIPADLKVOO/", Req_GenerateReportModel)
        return result.data;
    },

    getHistoryBuilderAndTransferSummary_Service: async (IPADLKVOO) => {


        //alert("getHistoryBuilderAndTransferSummary_Service: "+IPADLKVOO)
        const historyBuilderAndTransfer = await http.instance.get("/ReportSummary/GetReportSummariesWithHistoryByIPADLKVOO/",{params: {IPADLKVOO: IPADLKVOO}})

        console.log("historyBuilder")
        console.log(historyBuilderAndTransfer)
        return historyBuilderAndTransfer
    },

    getHistoryBuilderSummary_Service: async () => {
        const historyBuilder = await http.instance.get("/ReportSummary/")
        console.log("historyBuilder")
        console.log(historyBuilder)
        return historyBuilder
    },

    getTransferHistory_Service: async () => {
        const transferHistory = await http.instance.get("/ReportSummary/")
        console.log("transferHistory")
        console.log(transferHistory)
        return transferHistory
    },

    reportBuilderHistoryError_Service: async (form) => {
        console.log(form)

        const res = await http.instance.post("/HistoryError", form)
        return res.data;
    }
}

export default reportSummaryService
